import { Filters, SimpleEnumType } from '@/types';
import { NewsStatuses } from '@/enums';

export namespace News {
  export enum Pages {
    NEWS = 'news',
    NEWS_DETAIL = 'news/:id',
  }

  export interface News {
    [key: string]: unknown,
    id: number,
    type: SimpleEnumType<NewsStatuses>,
    image_path: string,
    title: string,
    preview_text: string,
    published_at: string,
    start_event_date: string,
    end_event_date: string,
    event_time: string,
    location: string,
    detail_text?: string,
    link?: string,
  }
}

export interface NewsFilters extends Filters {
  [key: string]: unknown,
  dates: string[],
}
